import { useDispatch } from 'react-redux'
import {confirmationDialog} from 'actions'

type ConfirmationPayload = {
  title?: string,
  message?: string,
  actionYes?: string,
  actionNo?: string
}

const useConfirmation = (payload = {} as ConfirmationPayload): (() => Promise<void>) => {
  const dispatch = useDispatch();

  return () => {
    return new Promise((resolve, reject) => {
      dispatch(confirmationDialog({...payload, resolve, reject}))
    })
  }
}

export default useConfirmation;